var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoCirurgiaGeral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ffbd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1686",
    "data-name": "Ret\\xE2ngulo 1686",
    width: 51.652,
    height: 16.224,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1691",
    "data-name": "Ret\\xE2ngulo 1691",
    width: 277.998,
    height: 62.768,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3895",
    "data-name": "Grupo 3895",
    transform: "translate(-280.578 -432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1759",
    "data-name": "Caminho 1759",
    d: "M0,0H285V128H0Z",
    transform: "translate(280.578 432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3914",
    "data-name": "Grupo 3914",
    transform: "translate(284.271 464.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3911",
    "data-name": "Grupo 3911",
    transform: "translate(226.346 46.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3910",
    "data-name": "Grupo 3910",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1685",
    "data-name": "Ret\\xE2ngulo 1685",
    width: 51.652,
    height: 16.224,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1687",
    "data-name": "Ret\\xE2ngulo 1687",
    width: 51.605,
    height: 43.674,
    transform: "translate(226.369 0.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1760",
    "data-name": "Caminho 1760",
    d: "M0,1.12V30H21.728V23.1H8.7V18.384H19.232V11.973H8.7V7.784H21.728V1.12Z",
    transform: "translate(0 -0.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1761",
    "data-name": "Caminho 1761",
    d: "M83.649,1.12l-8.394,13.4L84.982,30H74.666L69.333,20.9,63.951,30H55.838l9.3-14.912L56.218,1.12h10.34l4.481,7.772L75.69,1.12Z",
    transform: "translate(-33.691 -0.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1762",
    "data-name": "Caminho 1762",
    d: "M142.2,8.038V30h-8.4V8.038h-5.988V1.12h20.374V8.038Z",
    transform: "translate(-77.119 -0.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1763",
    "data-name": "Caminho 1763",
    d: "M207.258,23.1V30H185.53V1.12h21.728V7.784H194.225v4.189h10.536v6.411H194.225V23.1Z",
    transform: "translate(-111.945 -0.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3913",
    "data-name": "Grupo 3913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3912",
    "data-name": "Grupo 3912",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1764",
    "data-name": "Caminho 1764",
    d: "M273.859,30h-7.215l-7.909-12.76a48.6,48.6,0,0,1-3.071-5.964,20.094,20.094,0,0,1,.7,4.739V30h-7.193V1.12h8.378L264.276,11.7a40.776,40.776,0,0,1,3.046,5.544,41.989,41.989,0,0,1-.677-7.574V1.12h7.215Z",
    transform: "translate(-150.344 -0.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1765",
    "data-name": "Caminho 1765",
    d: "M316.6,20.966l8.23-1.481q1.036,3.491,5.331,3.491,3.343,0,3.343-1.777a1.649,1.649,0,0,0-.773-1.449,8.3,8.3,0,0,0-2.761-.92q-7.6-1.456-9.754-3.8A7.9,7.9,0,0,1,318.055,9.5a8.645,8.645,0,0,1,3.1-6.793Q324.253,0,330.072,0q8.823,0,11.657,7.088l-7.341,2.222a4.491,4.491,0,0,0-4.633-2.9q-2.9,0-2.9,1.8a1.423,1.423,0,0,0,.656,1.248,8.014,8.014,0,0,0,2.54.845,53.722,53.722,0,0,1,7.364,1.94,7.939,7.939,0,0,1,3.638,2.886,8.072,8.072,0,0,1,1.459,4.817,8.533,8.533,0,0,1-3.555,7.1,14.942,14.942,0,0,1-9.33,2.72q-10.558,0-13.033-8.8",
    transform: "translate(-191.027 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1688",
    "data-name": "Ret\\xE2ngulo 1688",
    width: 8.865,
    height: 28.879,
    transform: "translate(154.87 0.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1766",
    "data-name": "Caminho 1766",
    d: "M446.9,1.12,437.94,30h-9.034L419.535,1.12h9.342l4.57,15.741q.468,1.4.829,2.75L439.613,1.12Z",
    transform: "translate(-253.14 -0.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1767",
    "data-name": "Caminho 1767",
    d: "M503.789,29.768a13.086,13.086,0,0,1-9.933-4.041q-3.84-4.041-3.84-10.811a15.705,15.705,0,0,1,3.671-10.694Q497.357,0,503.874,0A12.98,12.98,0,0,1,513.7,3.978q3.8,3.978,3.8,10.621,0,6.876-3.829,11.023a12.838,12.838,0,0,1-9.88,4.147m-.042-6.559a3.352,3.352,0,0,0,3.226-1.957q.983-1.957.984-7.161,0-7.532-4.041-7.532-4.359,0-4.359,8.59,0,8.061,4.189,8.061",
    transform: "translate(-295.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1768",
    "data-name": "Caminho 1768",
    d: "M22.7,90.106v26.621H14.526V106.372H8.285v10.356H.113V90.106H8.285V99.9h6.241v-9.79Z",
    transform: "translate(-0.068 -54.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1769",
    "data-name": "Caminho 1769",
    d: "M80.058,116.728l-1.5-5.246H71.422l-1.6,5.246H63.189l8.218-26.621h8.64L88.4,116.728ZM72.811,105.67h4.307l-2.154-7.723Z",
    transform: "translate(-38.127 -54.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1770",
    "data-name": "Caminho 1770",
    d: "M156.624,116.727h-9.059l-3.888-10.18H141.1v10.18h-8.172V90.106h13.905q4.6,0,7.147,2.155a7.083,7.083,0,0,1,2.545,5.685,8.545,8.545,0,0,1-.936,4.067,7.88,7.88,0,0,1-3.783,3.111ZM141.1,100.852h3.491a4.3,4.3,0,0,0,2.477-.644A2.148,2.148,0,0,0,148,98.317q0-2.555-3.14-2.555H141.1Z",
    transform: "translate(-80.206 -54.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1771",
    "data-name": "Caminho 1771",
    d: "M202.408,116.727V90.106h10.3q6.708,0,10.044,3.978a13.907,13.907,0,0,1,3.335,9.205,13.443,13.443,0,0,1-3.579,9.7,12.292,12.292,0,0,1-9.293,3.735Zm8.172-6.124h2.126a4.1,4.1,0,0,0,3.423-1.97,9.134,9.134,0,0,0,1.394-5.363,9.718,9.718,0,0,0-1.238-5.012,3.928,3.928,0,0,0-3.579-2.106H210.58Z",
    transform: "translate(-122.129 -54.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1772",
    "data-name": "Caminho 1772",
    d: "M301.041,90.106l-7.061,26.621h-6.865l-3.724-14.686-3.517,14.686h-7.157l-7.073-26.621h7.69l3.723,15.322,3.633-15.322H287.1l3.952,15.352,3.729-15.352Z",
    transform: "translate(-160.284 -54.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1773",
    "data-name": "Caminho 1773",
    d: "M369.505,116.514a12.064,12.064,0,0,1-9.156-3.725q-3.54-3.725-3.54-9.966a14.478,14.478,0,0,1,3.384-9.858q3.383-3.891,9.39-3.891a11.966,11.966,0,0,1,9.059,3.666q3.5,3.667,3.5,9.791,0,6.339-3.53,10.161a11.834,11.834,0,0,1-9.108,3.822m-.039-6.046a3.09,3.09,0,0,0,2.974-1.8q.907-1.8.907-6.6,0-6.943-3.725-6.943-4.018,0-4.017,7.918,0,7.431,3.861,7.431",
    transform: "translate(-215.292 -53.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1774",
    "data-name": "Caminho 1774",
    d: "M453.084,116.727h-9.059l-3.888-10.18H437.56v10.18h-8.172V90.106h13.905q4.6,0,7.147,2.155a7.083,7.083,0,0,1,2.545,5.685,8.545,8.545,0,0,1-.936,4.067,7.88,7.88,0,0,1-3.783,3.111ZM437.56,100.852h3.491a4.3,4.3,0,0,0,2.477-.644,2.148,2.148,0,0,0,.936-1.891q0-2.555-3.14-2.555H437.56Z",
    transform: "translate(-259.085 -54.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1775",
    "data-name": "Caminho 1775",
    d: "M522.876,116.727h-8.941l-4.6-10.06-2.761,3.917v6.143h-7.7V90.106h7.7v11.007l7.341-11.007h7.344l-6.723,9.743Z",
    transform: "translate(-301.008 -54.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1776",
    "data-name": "Caminho 1776",
    d: "M582.315,130.539a2.689,2.689,0,1,1-5.378,0V122.6a2.689,2.689,0,1,1,5.378,0v3.175h-1.872V122.6q0-.873-.813-.88h-.013q-.807,0-.807.88v7.939q0,.88.814.88t.82-.88v-2.11h1.872Z",
    transform: "translate(-348.113 -72.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1689",
    "data-name": "Ret\\xE2ngulo 1689",
    width: 1.872,
    height: 12.98,
    transform: "translate(235.757 47.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1777",
    "data-name": "Caminho 1777",
    d: "M607.467,129.594l1.938,3.778h-2.05l-1.667-3.44h-.258v3.44h-1.872v-12.98h2.725q2.494.007,2.494,2.732V127.2a2.457,2.457,0,0,1-1.31,2.394m-2.037-7.362v5.914h.43a1.792,1.792,0,0,0,.536-.053.8.8,0,0,0,.51-.827v-4.148q0-.886-.814-.886Z",
    transform: "translate(-364.176 -72.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1778",
    "data-name": "Caminho 1778",
    d: "M626.182,130.851a2.69,2.69,0,1,1-5.379,0V120.392h1.872v10.459q0,.88.813.88t.821-.88V120.392h1.872Z",
    transform: "translate(-374.581 -72.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1779",
    "data-name": "Caminho 1779",
    d: "M642.443,129.594l1.939,3.778h-2.051l-1.667-3.44h-.258v3.44h-1.872v-12.98h2.726q2.494.007,2.494,2.732V127.2a2.456,2.456,0,0,1-1.31,2.394m-2.037-7.362v5.914h.43a1.792,1.792,0,0,0,.536-.053.8.8,0,0,0,.509-.827v-4.148q0-.886-.814-.886Z",
    transform: "translate(-385.279 -72.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1780",
    "data-name": "Caminho 1780",
    d: "M660.992,130.539a2.689,2.689,0,1,1-5.378,0V122.6a2.689,2.689,0,1,1,5.378,0v3.182H659.12V122.6q0-.873-.813-.88h-.013q-.807,0-.807.88v7.939q0,.88.813.88t.821-.88v-.92h-.813v-1.852h2.685Z",
    transform: "translate(-395.585 -72.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1690",
    "data-name": "Ret\\xE2ngulo 1690",
    width: 1.872,
    height: 12.98,
    transform: "translate(267.028 47.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1781",
    "data-name": "Caminho 1781",
    d: "M683.123,130.726l-.338,2.646H680.9l1.932-12.98H685.4l1.925,12.98h-1.892l-.338-2.646Zm1.746-1.786-.761-6.033-.761,6.033Z",
    transform: "translate(-410.842 -72.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1782",
    "data-name": "Caminho 1782",
    d: "M602.835,35.349l5.52,10.757h-5.84l-4.748-9.8h-.734v9.8H591.7V9.144h7.761q7.1.019,7.1,7.78V28.53q0,4.9-3.73,6.82m-5.8-20.968V31.224h1.224a5.139,5.139,0,0,0,1.526-.151,2.288,2.288,0,0,0,1.45-2.355V16.906q0-2.524-2.317-2.524Z",
    transform: "translate(-357.021 -5.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1783",
    "data-name": "Caminho 1783",
    d: "M651.275,15.433q0-2.487-2.317-2.505h-.038q-2.3,0-2.3,2.505v4.955H641.29V15.433q0-7.761,7.649-7.762,7.668,0,7.667,7.762v5.294q0,4.767-3.3,6.274,3.3,1.508,3.3,6.273V38.04q0,7.762-7.667,7.762-7.649,0-7.649-7.762V33.085h5.332V38.04q0,2.506,2.3,2.506h.038q2.317-.018,2.317-2.506V33.274q0-3.711-3.372-3.711h-1V24.306h1.413q2.958,0,2.958-3.617Z",
    transform: "translate(-386.942 -4.629)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoCirurgiaGeral);
export default __webpack_public_path__ + "static/media/extensivoCirurgiaGeral.f46823dd1310acb61106ec0f0234aae0.svg";
export { ForwardRef as ReactComponent };